<app-dynamic-text-widget [config]="config" [text]="text | titlecase"></app-dynamic-text-widget>
